import React from 'react'
import './headerBlog.css';

function HeaderBlog5() {
  return (
      <section id='home' className='section_headerBlog'>
        <div className='container headerBlog_main'>

           <div className='col-lg-6 col-md-12 col-sm-12 headerBlog_wrapper'>
                <div className='headerBlogPage_info'>Published on: Nov 18, 2025</div>
          <p className='headerBlogPage_info'>Author: Ponos Technology</p>
          <h2 className='headerBlogPage_title'>Tech Deep Dive: CryptoCPU – Powering FHE & ZKPs for Confidential Computing</h2>

           </div>
         
        </div>
    </section>
  )
}

export default HeaderBlog5
